import React, { Component, Fragment } from 'react';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import 'moment/locale/pt';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import Home from './Home/Home';

import Clients from './Clients/Clients';
import AddEditClient from './Clients/AddEditClient';
import PrintClient from './Clients/PrintClient';

import Appointments from './Appointments/Appointments';
import AddEditAppointment from './Appointments/AddEditAppointment';

import Staff from './Staff/Staff';
import AddEditStaff from './Staff/AddEditStaff';
import EditStaffSchedule from './Staff/EditStaffSchedule';
import PrintStaffSchedule from './Staff/PrintStaffSchedule';

import Services from './Services/Services';
import AddEditService from './Services/AddEditService';

import Products from './Products/Products';
import AddEditProduct from './Products/AddEditProduct';

import Suppliers from './Suppliers/Suppliers';
import AddEditSupplier from './Suppliers/AddEditSupplier';

import Stores from './Stores/Stores';
import AddEditStore from './Stores/AddEditStore';
import StoreStock from './Stores/StoreStock';

import Communications from './Communications/Communications';
import AddEditCommunication from './Communications/AddEditCommunication';

import Settings from './Settings/Settings';

import Users from './Users/Users';
import AddEditUser from './Users/AddEditUser';
import UserProfile from './Users/UserProfile';

import Cart from './Cart/Cart';
import Orders from './Orders/Orders';
import ViewEditOrder from './Orders/ViewEditOrder';
import PrintOrder from './Orders/PrintOrder';

import Payments from './Payments/Payments';
import PrintPayments from './Payments/PrintPayments';

import ToTop from './Common/ToTop/ToTop';
import Header from './Common/Header/Header';
import Footer from './Common/Footer/Footer';

import LoginPanel from './LoginPanel';
import Forbidden from './Forbidden';
import NotFound from './NotFound';
import MainNav from './MainNav';

import { API, LOGIN_LEVELS, configUrl } from '../ws/constants';
import './App.css';

const defaultConfig = require('../cfg/config.json');

class Layout extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loggedIn: false
            , websiteSettings: null
            , loginData: null
            , isNavOpen: true
            , loading: false
            , showLoading: true
            , config: null
            , newNotes: []
        };
    }
    componentDidMount() {
        let user = sessionStorage.getItem("loginUser")
            , pw = sessionStorage.getItem("loginPass");

        if (sessionStorage.getItem("loginUser") != null && sessionStorage.getItem("loginPass") != null) {
            this.doLogin(user, pw);
        
            setInterval(() => {
                this.getUnseenNotes();
            }, 10 * 60 * 1000);
        }

        this.getBasicSettings();

        fetch(configUrl)
        .then(response => response.json())
        .then(config => this.setState({ config }))
        .catch((error) => {
            console.warn("Error getting config: ", error);
            this.setState({ config: defaultConfig });
        });
    }

    getBasicSettings = () => {  
        fetch(API + "getbasicsettings")
        .then(response => response.json())
        .then(data => {
            setTimeout(() => this.setState({ websiteSettings: data.data[0] }, () => { document.title = this.state.websiteSettings?.Title }), 2000)
        })
        .catch((error) => {
            console.warn("error fetching website settings");
            throw(error);
        });
    }

    getUnseenNotes = () => {
        fetch(API + 'getunseennotes&cur_userid=' + this.state.loginData.data.Id)
        .then(response => response.json())
        .then(result => {
            this.setState({ newNotes: result.data });
        });
    }

    doLogin = (username, password) => {
        /*let DEFAULT_QUERY = "getwebsitesettings";
        fetch(API + DEFAULT_QUERY)
        .then(response => response.json())
        .then(data => {this.setState({ websiteSettings: data })});*/

        this.setState({ loading: true });
        /*const data = JSON.stringify({
            username: "username"
            ,password: "password"
        })*/
        /*fetch(API + "login", {
            method: 'POST'
            ,headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
            ,body: data
        })*/
        fetch(API + "login&username=" + username + "&password=" + password, {
            headers: {
                'Access-Control-Request-Headers': '*',
            },
        })
        .then(response => response.json())
        .then(data => {
            if (!data) return;

            const successLogin = data.shortmsg === "OK";
            const newState = { loggedIn: successLogin, loading: false };

            if (successLogin) {
                sessionStorage.setItem('loginUser', username);
                sessionStorage.setItem('loginPass', password);

                newState.loginData = this.handleProfileData(data);
            } else {
                newState.loginData = data;
                sessionStorage.clear();
            }

            this.setState(newState, this.getUnseenNotes);
        });
    }

    handleProfileData(data) {
        const ret = JSON.parse(JSON.stringify(data));
        const profile = data.data.profile;
        const newProfile = { Pages: {} };

        for (let i = 0, n = profile.length; i < n; i++) {
            if (!profile[i].Field) { // Handle Pages
                newProfile[profile[i].Page] = { permission: parseInt(profile[i].Permission, 10) };
            } else { // Handle Fields
                if (newProfile[profile[i].Page]) {
                    newProfile[profile[i].Page][profile[i].Field] = { permission: parseInt(profile[i].Permission, 10) };
                }
            }
        }
        ret.data.profile = newProfile;
        return ret;
    }

    openCloseNav = (isNavOpen) => {
        this.setState({ isNavOpen: isNavOpen });
    }
    closeLoading = () => {
        this.setState({ showLoading: !this.state.showLoading });
    }

    render() {
        const { loggedIn, loginData, config, websiteSettings, showLoading, newNotes } = this.state;

        if (!config || !websiteSettings) {
            return <Backdrop open={showLoading} onClick={this.handleClose}>
                       <CircularProgress color="inherit" />
                    </Backdrop>;
        }

        const loginLevel = loginData !== null && loginData.shortmsg === "OK" ? parseInt(loginData.data.AccessLevel, 10) : 99;
        const isAdmin = loggedIn && loginLevel <= LOGIN_LEVELS.ADMIN;
        const openNav = this.state.isNavOpen ? "" : "miniNav";
        const errorMessage = loginData !== null && loginData.message;
        const themeV1 = createMuiTheme({
            typography: {
                useNextVariants: true,
            },
            palette: config.colors.palette            
        });

        return (
            <MuiThemeProvider theme={themeV1}>
                <MuiPickersUtilsProvider utils={MomentUtils} locale="pt" moment={moment}>
                    <BrowserRouter>
                        <div id="fullPageWrapper" className={openNav}>
                            <Route render={(props) => <Header isLoggedIn={loggedIn} loginData={loginData?.data} config={config} websiteSettings={websiteSettings} newNotes={newNotes} getUnseenNotes={this.getUnseenNotes} isAdmin={isAdmin} />} />
                            {
                                !loggedIn ?
                                    <div className="pageContent">
                                        <LoginPanel loading={this.state.loading} errorMessage={errorMessage} doLogin={this.doLogin} />
                                    </div> :
                                    <Fragment>
                                        <div className={"container pageContent " + showLoading}>
                                            <div className="row contentHolder">
                                                <div id="navHolder" className="col-md-5 col-lg-3">
                                                    <Route render={(props) => <MainNav isAdmin={isAdmin} config={config} loginData={loginData?.data} openCloseNav={this.openCloseNav} />} />
                                                </div>
                                                <div id="rightSideHolder" className="col-md-7 col-lg-9">
                                                    <Switch>
                                                        <Route exact path="/" render={(props) => <Home props={props} isAdmin={isAdmin} />} />
                                                        {(isAdmin || loginData.data.profile.Clients) && <Route exact path="/Clients/" render={(props) => <Clients props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {(isAdmin || loginData.data.profile.Clients) && <Route path="/Clients/:id" render={(props) => <AddEditClient props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {(isAdmin || loginData.data.profile.Appointments) && <Route exact path="/Appointments/" render={(props) => <Appointments props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {(isAdmin || loginData.data.profile.Appointments) && <Route path="/Appointments/:id" render={(props) => <AddEditAppointment props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {(isAdmin || loginData.data.profile.Staff) && <Route exact path="/Staff/" render={(props) => <Staff props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {(isAdmin || loginData.data.profile.Staff) && <Route exact path="/Staff/:id" render={(props) => <AddEditStaff props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {(isAdmin || (loginData.data.profile.Staff && loginData.data.profile.Schedules)) && <Route exact path="/Staff/Schedules/:id" render={(props) => <EditStaffSchedule props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {config.features.services && (isAdmin || loginData.data.profile.Services) && <Route exact path="/Services/" render={(props) => <Services props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {config.features.services && (isAdmin || loginData.data.profile.Services) && <Route path="/Services/:id" render={(props) => <AddEditService props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {config.features.products && (isAdmin || loginData.data.profile.Cart) && <Route exact path="/Cart/" render={(props) => <Cart props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {config.features.products && (isAdmin || (loginData.data.profile.Cart && loginData.data.profile.Cart.viewAllOrders)) && <Route exact path="/Orders/" render={(props) => <Orders props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {config.features.products && (isAdmin || (loginData.data.profile.Cart && loginData.data.profile.Cart.viewAllOrders)) && <Route exact path="/Orders/:id" render={(props) => <ViewEditOrder props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {config.features.payments && (isAdmin || loginData.data.profile.Payments) && <Route exact path="/Payments/" render={(props) => <Payments props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {config.features.products && (isAdmin || loginData.data.profile.Products) && <Route exact path="/Products/" render={(props) => <Products props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {config.features.products && (isAdmin || loginData.data.profile.Products) && <Route path="/Products/:id" render={(props) => <AddEditProduct props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {config.features.products && (isAdmin || loginData.data.profile.Suppliers) && <Route exact path="/Suppliers/" render={(props) => <Suppliers props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {config.features.products && (isAdmin || loginData.data.profile.Suppliers) && <Route path="/Suppliers/:id" render={(props) => <AddEditSupplier props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {(isAdmin || loginData.data.profile.Stores) && <Route exact path="/Stores/" render={(props) => <Stores props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {(isAdmin || loginData.data.profile.Stores) && <Route exact path="/Stores/:id" render={(props) => <AddEditStore props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {config.features.products && (isAdmin || (loginData.data.profile.Stores && loginData.data.profile.StoreStock)) && <Route path="/Stores/StoreStock/:id" render={(props) => <StoreStock props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {config.features.communications && (isAdmin || loginData.data.profile.Communications) && <Route exact path="/Communications/" render={(props) => <Communications props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {config.features.communications && (isAdmin || loginData.data.profile.Communications) && <Route path="/Communications/:id" render={(props) => <AddEditCommunication props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {config.features.settings && (isAdmin || loginData.data.profile.Settings) && <Route path="/Settings/" render={(props) => <Settings props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} refreshBasicSettings={this.getBasicSettings} />} />}
                                                        {(isAdmin || loginData.data.profile.Users) && <Route exact path="/Users/" render={(props) => <Users props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        <Route exact path="/Users/:id" render={(props) => <AddEditUser props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />
                                                        {config.features.profile && (isAdmin || (loginData.data.profile.Users && loginData.data.profile.UserProfile)) && <Route path="/Users/UserProfile/:id/:name" render={(props) => <UserProfile props={props} config={config} websiteSettings={websiteSettings} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                                        {loggedIn &&
                                                            <Route render={(props) => <Forbidden props={props} loginLevel={loginLevel} isAdmin={isAdmin} />} />
                                                        }
                                                        <Route render={(props) => <NotFound props={props} isAdmin={isAdmin} />} />
                                                    </Switch>
                                                </div>
                                            </div>
                                            <ToTop />
                                        </div>
                                        {(isAdmin || (loginData.data.profile.Schedules && loginData.data.profile.Schedules.canPrintSchedule)) && <Route path="/PrintStaffSchedule/:id/:month/:year" render={(props) => <PrintStaffSchedule props={props} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                        {(isAdmin || (loginData.data.profile.Payments && loginData.data.profile.Payments.canPrintPayments)) && <Route path="/PrintPayments/:date/:staff?/:client?/:stores?/:order/:orderBy/:rowsPerPage/:page" render={(props) => <PrintPayments props={props} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                        {(isAdmin || (loginData.data.profile.Clients && loginData.data.profile.Clients.canPrint)) && <Route path="/PrintOrder/:id" render={(props) => <PrintOrder props={props} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                        {(isAdmin || (loginData.data.profile.Cart && loginData.data.profile.Cart.canPrint)) && <Route path="/PrintClient/:id" render={(props) => <PrintClient props={props} loginData={loginData.data} isAdmin={isAdmin} />} />}
                                    </Fragment>
                            }
                            <Route component={Footer} />
                        </div>
                    </BrowserRouter>
                </MuiPickersUtilsProvider>
            </MuiThemeProvider>
        );
    }
}

export default Layout;
